/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForInventoryUnitRate extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForInventoryUnitRate");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForInventoryUnitRate.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForInventoryUnitRate>): BackgroundJobPayloadForInventoryUnitRate {
        let obj = Object.assign(new BackgroundJobPayloadForInventoryUnitRate(), model);
        BackgroundJobPayloadForInventoryUnitRate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForInventoryUnitRate>): BackgroundJobPayloadForInventoryUnitRate {
        if (!model) return null;
        return BackgroundJobPayloadForInventoryUnitRate.newInstance(<BackgroundJobPayloadForInventoryUnitRate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForInventoryUnitRate) {
        if (!obj) return;

        models.BackgroundJobPayloadForInventoryUnitRate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForInventoryUnitRate): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForInventoryUnitRate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * cloud service name
     */
    service_name: models.CloudServiceName;

    service_account_id: string;

}
